// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const getStronglyTypedKeys = Object.keys as <T extends object>(
  obj: T,
) => Array<keyof T>;
